module.exports = __webpack_public_path__ + "img/assistantAccount-crm-warp2-img3.84bde0ff.png";